import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card d-block" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-md-8" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_8 = { "aria-label": "breadcrumb" }
const _hoisted_9 = { class: "breadcrumb mb-0" }
const _hoisted_10 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_11 = { class: "breadcrumb-item" }
const _hoisted_12 = { class: "breadcrumb-item" }
const _hoisted_13 = { href: "javascript:void(0)" }
const _hoisted_14 = {
  key: 0,
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_15 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_16 = { class: "col-lg-4" }
const _hoisted_17 = { class: "text-lg-right" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_19 = { class: "card d-block" }
const _hoisted_20 = {
  key: 0,
  class: "row"
}
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { for: "" }, "Smart Contract Name", -1)
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { for: "" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { for: "" }
const _hoisted_30 = { class: "form-group bg-light p-3" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = { for: "" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { for: "" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = { for: "" }
const _hoisted_41 = {
  key: 1,
  class: "text-center"
}
const _hoisted_42 = {
  key: 2,
  class: "form-group"
}
const _hoisted_43 = { for: "" }
const _hoisted_44 = { class: "form-group mt-3" }
const _hoisted_45 = {
  key: 0,
  for: ""
}
const _hoisted_46 = { class: "required" }
const _hoisted_47 = { key: 3 }
const _hoisted_48 = { class: "row align-items-center mb-2" }
const _hoisted_49 = { class: "col-sm-6" }
const _hoisted_50 = { class: "form-check form-check-inline mb-2" }
const _hoisted_51 = {
  for: "",
  title: "Phase Name"
}
const _hoisted_52 = { class: "col-sm-6" }
const _hoisted_53 = { class: "text-sm-right" }
const _hoisted_54 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_56 = { class: "row my-1" }
const _hoisted_57 = { class: "col-md-4" }
const _hoisted_58 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_59 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-money-bill-wave" })
], -1)
const _hoisted_60 = { class: "desc-wrap" }
const _hoisted_61 = { class: "col-md-4" }
const _hoisted_62 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1 green-bordered-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar-check" })
], -1)
const _hoisted_64 = { class: "desc-wrap" }
const _hoisted_65 = { class: "to-upper" }
const _hoisted_66 = { class: "col-md-4" }
const _hoisted_67 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_68 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1 red-bordered-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar-times" })
], -1)
const _hoisted_69 = { class: "desc-wrap" }
const _hoisted_70 = { class: "mt-4" }
const _hoisted_71 = {
  key: 0,
  class: "border rounded bg-light p-3 mt-2 pb-0"
}
const _hoisted_72 = { class: "row align-items-center mb-2" }
const _hoisted_73 = { class: "col-sm-6" }
const _hoisted_74 = { class: "form-check form-check-inline mb-2" }
const _hoisted_75 = {
  for: "",
  title: "Phase Name"
}
const _hoisted_76 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_77 = { class: "members-list pt-sm-0 text-sm-right" }
const _hoisted_78 = { class: "row my-1" }
const _hoisted_79 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_80 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_81 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-money-bill-wave" })
], -1)
const _hoisted_82 = { class: "desc-wrap" }
const _hoisted_83 = { class: "mt-2" }
const _hoisted_84 = { class: "mt-2" }
const _hoisted_85 = {
  key: 0,
  class: "list-accordion mt-2"
}
const _hoisted_86 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_87 = { class: "mb-0" }
const _hoisted_88 = { class: "card-body p-2" }
const _hoisted_89 = { class: "row" }
const _hoisted_90 = { class: "col-md-6" }
const _hoisted_91 = { class: "to-upper" }
const _hoisted_92 = { class: "col-md-6" }
const _hoisted_93 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_94 = {
  key: 2,
  class: "border rounded bg-light p-3 mt-2 pb-0"
}
const _hoisted_95 = {
  key: 0,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_96 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_97 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_98 = { class: "sr-only" }
const _hoisted_99 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_100 = { class: "imaged-col" }
const _hoisted_101 = { class: "small-img-wrap" }
const _hoisted_102 = { class: "size" }
const _hoisted_103 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_104 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_105 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_106 = { class: "sr-only" }
const _hoisted_107 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_108 = { class: "imaged-col" }
const _hoisted_109 = { class: "small-img-wrap" }
const _hoisted_110 = { class: "size" }
const _hoisted_111 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_112 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_113 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_114 = { class: "sr-only" }
const _hoisted_115 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_116 = { class: "imaged-col" }
const _hoisted_117 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_118 = { class: "size" }
const _hoisted_119 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_120 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_121 = { class: "centered-wrap" }
const _hoisted_122 = {
  class: "spinner-border big-spinner",
  role: "status"
}
const _hoisted_123 = { class: "sr-only" }
const _hoisted_124 = { class: "size" }
const _hoisted_125 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_126 = {
  key: 4,
  class: "my-3"
}
const _hoisted_127 = { key: 5 }
const _hoisted_128 = {
  key: 6,
  class: "bg-light rounded p-3 border mt-3"
}
const _hoisted_129 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_130 = {
  key: 0,
  class: "company-logo-wrap border p-1 rounded my-3 bg-white"
}
const _hoisted_131 = { class: "tab-wrap bg-white rounded px-3 pb-3 border" }
const _hoisted_132 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_133 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_134 = {
  class: "nav-link active",
  id: "Contract-tab",
  "data-toggle": "tab",
  "data-target": "#Contract",
  type: "button",
  role: "tab",
  "aria-controls": "Contract",
  "aria-selected": "true"
}
const _hoisted_135 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_136 = {
  class: "nav-link",
  id: "Contract1-tab",
  "data-toggle": "tab",
  "data-target": "#Contract1",
  type: "button",
  role: "tab",
  "aria-controls": "Contract1",
  "aria-selected": "false"
}
const _hoisted_137 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_138 = {
  class: "tab-pane fade show active",
  id: "Contract",
  role: "tabpanel",
  "aria-labelledby": "Contract-tab"
}
const _hoisted_139 = {
  class: "tab-pane fade",
  id: "Contract1",
  role: "tabpanel",
  "aria-labelledby": "Contract1-tab"
}
const _hoisted_140 = { class: "inline-items mt-3" }
const _hoisted_141 = {
  key: 0,
  class: "mr-3"
}
const _hoisted_142 = { for: "" }
const _hoisted_143 = /*#__PURE__*/_createVNode("span", { class: "required" }, "*", -1)
const _hoisted_144 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_145 = { class: "form-group" }
const _hoisted_146 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_147 = { class: "form-group" }
const _hoisted_148 = { class: "inline-items" }
const _hoisted_149 = { class: "upload-btn-wrapper" }
const _hoisted_150 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_151 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_152 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eraser" }, null, -1)
const _hoisted_153 = { key: 0 }
const _hoisted_154 = { class: "upload-btn-wrapper" }
const _hoisted_155 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_156 = { class: "form-group" }
const _hoisted_157 = { for: "" }
const _hoisted_158 = {
  key: 0,
  class: "image-in-chat preview-image-list"
}
const _hoisted_159 = { class: "row mx-n2" }
const _hoisted_160 = {
  key: 0,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_161 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_162 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_163 = { class: "sr-only" }
const _hoisted_164 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_165 = { class: "imaged-col" }
const _hoisted_166 = { class: "small-img-wrap" }
const _hoisted_167 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_168 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_169 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_170 = { class: "sr-only" }
const _hoisted_171 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_172 = { class: "imaged-col" }
const _hoisted_173 = { class: "small-img-wrap" }
const _hoisted_174 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_175 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_176 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_177 = { class: "sr-only" }
const _hoisted_178 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_179 = { class: "imaged-col" }
const _hoisted_180 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_181 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_182 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_183 = { class: "centered-wrap" }
const _hoisted_184 = {
  class: "spinner-border big-spinner",
  role: "status"
}
const _hoisted_185 = { class: "sr-only" }
const _hoisted_186 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_187 = {
  key: 0,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_188 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_189 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_190 = { class: "sr-only" }
const _hoisted_191 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_192 = { class: "imaged-col" }
const _hoisted_193 = { class: "small-img-wrap" }
const _hoisted_194 = { class: "size" }
const _hoisted_195 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_196 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_197 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_198 = { class: "sr-only" }
const _hoisted_199 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_200 = { class: "imaged-col" }
const _hoisted_201 = { class: "small-img-wrap" }
const _hoisted_202 = { class: "size" }
const _hoisted_203 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_204 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_205 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_206 = { class: "sr-only" }
const _hoisted_207 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_208 = { class: "imaged-col" }
const _hoisted_209 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_210 = { class: "size" }
const _hoisted_211 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_212 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_213 = { class: "centered-wrap" }
const _hoisted_214 = {
  class: "spinner-border big-spinner",
  role: "status"
}
const _hoisted_215 = { class: "sr-only" }
const _hoisted_216 = { class: "size" }
const _hoisted_217 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_218 = { class: "bg-light p-2 rounded border mb-3" }
const _hoisted_219 = {
  key: 0,
  class: "row mx-n2"
}
const _hoisted_220 = {
  key: 0,
  class: "shadowed-card bg-white h-100 p-2"
}
const _hoisted_221 = { class: "row mx-n2" }
const _hoisted_222 = { class: "col-xl-6 px-2" }
const _hoisted_223 = { class: "form-group" }
const _hoisted_224 = { for: "" }
const _hoisted_225 = { class: "text-red" }
const _hoisted_226 = { class: "col-xl-6 px-2" }
const _hoisted_227 = { class: "form-group" }
const _hoisted_228 = { for: "" }
const _hoisted_229 = { class: "col-xl-6 px-2" }
const _hoisted_230 = { class: "form-group" }
const _hoisted_231 = { for: "" }
const _hoisted_232 = { class: "col-xl-6 px-2" }
const _hoisted_233 = { class: "form-group" }
const _hoisted_234 = {
  for: "",
  class: "to-upper"
}
const _hoisted_235 = { class: "input-group" }
const _hoisted_236 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "+1")
], -1)
const _hoisted_237 = { class: "text-red" }
const _hoisted_238 = { class: "col-xl-6 px-2" }
const _hoisted_239 = { class: "form-group" }
const _hoisted_240 = { for: "" }
const _hoisted_241 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_242 = { class: "form-check form-check-inline" }
const _hoisted_243 = {
  class: "form-check-label",
  for: "inlineCheckbox1"
}
const _hoisted_244 = { class: "form-check form-check-inline" }
const _hoisted_245 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_246 = { class: "text-red" }
const _hoisted_247 = { class: "col-xl-6 px-2" }
const _hoisted_248 = { class: "form-group" }
const _hoisted_249 = { for: "" }
const _hoisted_250 = { class: "text-end" }
const _hoisted_251 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check-circle" }, null, -1)
const _hoisted_252 = {
  key: 1,
  class: "shadowed-card bg-white h-100 p-2"
}
const _hoisted_253 = { class: "text-end" }
const _hoisted_254 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pencil-alt" }, null, -1)
const _hoisted_255 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" }, null, -1)
const _hoisted_256 = { class: "row mx-n2" }
const _hoisted_257 = { class: "col-xl-6 px-2" }
const _hoisted_258 = { class: "mb-3" }
const _hoisted_259 = { class: "col-xl-6 px-2" }
const _hoisted_260 = { class: "mb-3" }
const _hoisted_261 = { class: "col-xl-6 px-2" }
const _hoisted_262 = { class: "mb-3" }
const _hoisted_263 = { class: "col-xl-6 px-2" }
const _hoisted_264 = { class: "mb-3" }
const _hoisted_265 = { class: "to-upper" }
const _hoisted_266 = { class: "col-xl-6 px-2" }
const _hoisted_267 = { class: "mb-3" }
const _hoisted_268 = { key: 0 }
const _hoisted_269 = /*#__PURE__*/_createTextVNode("       ")
const _hoisted_270 = { key: 1 }
const _hoisted_271 = { class: "col-xl-6 px-2" }
const _hoisted_272 = { class: "mb-3" }
const _hoisted_273 = {
  key: 1,
  class: "alert alert-warning text-center",
  role: "alert"
}
const _hoisted_274 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle me-1" }, null, -1)
const _hoisted_275 = { class: "form-group" }
const _hoisted_276 = { for: "" }
const _hoisted_277 = {
  key: 7,
  class: "form-check form-check-inline mb-2"
}
const _hoisted_278 = {
  for: "Approve By All Members",
  title: "Approve By All Members"
}
const _hoisted_279 = { class: "form-check form-check-inline mb-2" }
const _hoisted_280 = {
  for: "Is Individual Phase Accept Required",
  title: "Is Individual Phase Accept Required"
}
const _hoisted_281 = { class: "form-group mt-3" }
const _hoisted_282 = {
  key: 0,
  for: ""
}
const _hoisted_283 = { class: "required" }
const _hoisted_284 = { class: "modal-wrap default-modal" }
const _hoisted_285 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: -1,
  "aria-labelledby": "showPojectLabel",
  "aria-hidden": "true"
}
const _hoisted_286 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_287 = { class: "modal-content" }
const _hoisted_288 = { class: "modal-header" }
const _hoisted_289 = {
  class: "modal-title to-upper",
  id: "showPojectLabel"
}
const _hoisted_290 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_291 = { class: "modal-body" }
const _hoisted_292 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_293 = { class: "modal-footer" }
const _hoisted_294 = { class: "modal-wrap default-modal" }
const _hoisted_295 = {
  class: "modal fade",
  id: "addCompanyInfo",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_296 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_297 = { class: "modal-content" }
const _hoisted_298 = { class: "modal-header" }
const _hoisted_299 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_300 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_301 = { class: "modal-body" }
const _hoisted_302 = { class: "row" }
const _hoisted_303 = { class: "col-md-12" }
const _hoisted_304 = {
  key: 0,
  class: "form-group"
}
const _hoisted_305 = { for: "" }
const _hoisted_306 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_307 = { class: "form-group" }
const _hoisted_308 = {
  for: "",
  class: "to-upper"
}
const _hoisted_309 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_310 = { class: "form-group" }
const _hoisted_311 = {
  for: "",
  class: "to-upper"
}
const _hoisted_312 = { class: "form-group" }
const _hoisted_313 = { for: "" }
const _hoisted_314 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_315 = { class: "custom-file" }
const _hoisted_316 = { class: "upload-btn-wrapper" }
const _hoisted_317 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_318 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_319 = { class: "form-group" }
const _hoisted_320 = { for: "" }
const _hoisted_321 = { class: "form-group" }
const _hoisted_322 = { for: "" }
const _hoisted_323 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_DragAndDropZone = _resolveComponent("DragAndDropZone")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_SendEstimationInvitationAddPhaseModal = _resolveComponent("SendEstimationInvitationAddPhaseModal")
  const _component_Editor = _resolveComponent("Editor")
  const _component_AppDeleteConfirmationModal = _resolveComponent("AppDeleteConfirmationModal")
  const _component_SignaturePadModal = _resolveComponent("SignaturePadModal")
  const _component_SignatureUploadModal = _resolveComponent("SignatureUploadModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      (_ctx.state.ui.isLoading.loadDetailsData ||
      _ctx.state.ui.isLoading.getSmartContractDetails
    )
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t('create_smart_contract')), 1),
              _createVNode("div", _hoisted_7, [
                _createVNode("nav", _hoisted_8, [
                  _createVNode("ol", _hoisted_9, [
                    _hoisted_10,
                    _createVNode("li", _hoisted_11, [
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToProjectToDo && _ctx.redirectToProjectToDo(...args)))
                      }, _toDisplayString(_ctx.state.data.projectEstimations.name), 1)
                    ]),
                    _createVNode("li", _hoisted_12, [
                      _createVNode("a", _hoisted_13, _toDisplayString(_ctx.$t('smart_contract')), 1)
                    ]),
                    (_ctx.state.data.estimation.title && _ctx.state.data.estimation)
                      ? (_openBlock(), _createBlock("li", _hoisted_14, [
                          _createVNode("a", _hoisted_15, _toDisplayString(_ctx.state.data.estimation.title), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn outline d-inline-block",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToProjectToDo && _ctx.redirectToProjectToDo(...args)))
                }, [
                  _hoisted_18,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode(_component_ErrorList, {
            errors: _ctx.state.ui.errors.errorList.approval,
            hasError: _ctx.state.ui.errors.hasError
          }, null, 8, ["errors", "hasError"]),
          (_ctx.state.data.estimation.title && _ctx.state.data.estimation)
            ? (_openBlock(), _createBlock("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _withDirectives(_createVNode("input", {
                      disabled: "",
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.estimation.title = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.estimation.title]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_24, [
            _createVNode("div", _hoisted_25, [
              _createVNode("div", _hoisted_26, [
                _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('project_name')), 1),
                _withDirectives(_createVNode("input", {
                  disabled: "",
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.projectEstimations.name = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectEstimations.name]
                ])
              ]),
              _createVNode("div", _hoisted_28, [
                _createVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('total_project_estimation')), 1),
                _createVNode("div", _hoisted_30, _toDisplayString(_ctx.usdPriceFormate(_ctx.state.data.projectEstimations.estimatedBudget, null)), 1)
              ])
            ]),
            _createVNode("div", _hoisted_31, [
              _createVNode("div", _hoisted_32, [
                _createVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('project_details')), 1),
                _withDirectives(_createVNode("textarea", {
                  disabled: "",
                  class: "form-control",
                  rows: "6",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.projectEstimations.description = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectEstimations.description]
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_34, [
            _createVNode("div", _hoisted_35, [
              _createVNode("div", _hoisted_36, [
                _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('project_start_date')), 1),
                _createVNode(_component_v_date_picker, {
                  modelValue: _ctx.state.data.projectEstimations.startDate,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.projectEstimations.startDate = $event)),
                  "min-date": _ctx.state.data.todayData
                }, {
                  default: _withCtx(({ inputValue, inputEvents }) => [
                    _createVNode("input", _mergeProps({
                      class: _ctx.state.ui.isLoading.projectStartDate
                    ? 'form-control error-field'
                    : 'form-control'
                    ,
                      value: inputValue
                    }, _toHandlers(inputEvents), {
                      placeholder: _ctx.$t('select_start_date')
                    }), null, 16, ["value", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "min-date"])
              ])
            ]),
            _createVNode("div", _hoisted_38, [
              _createVNode("div", _hoisted_39, [
                _createVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('project_end_date')), 1),
                _createVNode(_component_v_date_picker, {
                  modelValue: _ctx.state.data.projectEstimations.endDate,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.projectEstimations.endDate = $event)),
                  "min-date": _ctx.state.data.projectEstimations.startDate,
                  class: !_ctx.state.data.projectEstimations.startDate ? 'disabled' : ''
                  
                }, {
                  default: _withCtx(({ inputValue, inputEvents }) => [
                    _createVNode("input", _mergeProps({
                      disabled: !_ctx.state.data.projectEstimations.startDate,
                      class: _ctx.state.ui.isLoading.projectEndDate
                    ? 'form-control error-field'
                    : 'form-control'
                    ,
                      value: inputValue
                    }, _toHandlers(inputEvents), {
                      placeholder: _ctx.$t('select_end_date')
                    }), null, 16, ["disabled", "value", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "min-date", "class"])
              ])
            ])
          ]),
          (_ctx.state.data.isActiveEdocLink)
            ? (_openBlock(), _createBlock("div", _hoisted_41, [
                _createVNode("p", null, _toDisplayString(_ctx.$t('or')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.data.isActiveEdocLink)
            ? (_openBlock(), _createBlock("div", _hoisted_42, [
                _createVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('edoc_link')), 1),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.projectEstimations.edocLink = $event)),
                  placeholder: "https://qa.convorally.com"
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectEstimations.edocLink]
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_44, [
            _createVNode("button", {
              type: "submit",
              disabled: _ctx.hasValidIds,
              class: "btn default-btn d-inline-block mr-2",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showAddPhaseModal && _ctx.showAddPhaseModal(...args)))
            }, _toDisplayString(_ctx.$t('add_phase')), 9, ["disabled"]),
            (_ctx.state.ui.isLoading.projectStartDate &&
            _ctx.state.ui.isLoading.projectEndDate
          )
              ? (_openBlock(), _createBlock("label", _hoisted_45, [
                  _createVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('project_start_end_date_required')), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.state.data.createPhase.length > 0)
            ? (_openBlock(), _createBlock("p", _hoisted_47, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('phases')), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.createPhase, (phase, phaseIndex) => {
            return (_openBlock(), _createBlock("div", {
              class: "border p-3 rounded my-2",
              key: phaseIndex
            }, [
              _createVNode("div", _hoisted_48, [
                _createVNode("div", _hoisted_49, [
                  _createVNode("div", _hoisted_50, [
                    _createVNode("label", _hoisted_51, _toDisplayString(phase.name), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_52, [
                  _createVNode("div", _hoisted_53, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn btn-sm text-primary mr-2",
                      title: "Edit",
                      onClick: ($event: any) => (_ctx.editNewPhase(phase, phaseIndex))
                    }, [
                      _hoisted_54,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                    ], 8, ["onClick"]),
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn btn-sm text-danger",
                      title: "delete",
                      onClick: ($event: any) => (_ctx.selectForDeletePhase(phase))
                    }, [
                      _hoisted_55,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                    ], 8, ["onClick"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_56, [
                _createVNode("div", _hoisted_57, [
                  _createVNode("div", _hoisted_58, [
                    _hoisted_59,
                    _createVNode("div", _hoisted_60, [
                      _createVNode("p", null, _toDisplayString(_ctx.$t('estimation')), 1),
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.usdPriceFormate(phase.budget, null)), 1)
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_61, [
                  _createVNode("div", _hoisted_62, [
                    _hoisted_63,
                    _createVNode("div", _hoisted_64, [
                      _createVNode("p", _hoisted_65, _toDisplayString(_ctx.$t('start_date')), 1),
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(phase.startDate), 1)
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_66, [
                  _createVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createVNode("div", _hoisted_69, [
                      _createVNode("p", null, _toDisplayString(_ctx.$t('end_date')), 1),
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(phase.endDate), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_70, [
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_description')) + " : ", 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("small", null, _toDisplayString(phase.description), 1)
                ])
              ]),
              (phase.child_phases || phase.tasks)
                ? (_openBlock(), _createBlock("div", _hoisted_71, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.child_phases ||
              phase.groupTasks, (task, taskIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "mb-3 border-bottom pb-3",
                        key: taskIndex
                      }, [
                        _createVNode("div", _hoisted_72, [
                          _createVNode("div", _hoisted_73, [
                            _createVNode("div", _hoisted_74, [
                              _createVNode("label", _hoisted_75, _toDisplayString(task.name), 1)
                            ])
                          ]),
                          (task.allMembers)
                            ? (_openBlock(), _createBlock("div", _hoisted_76, [
                                _createVNode("div", _hoisted_77, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.allMembers, (user, userIndex) => {
                                    return (_openBlock(), _createBlock("a", {
                                      href: "javascript:void(0)",
                                      key: userIndex
                                    }, [
                                      _createVNode("span", null, [
                                        _createVNode("img", {
                                          src: user.image
                          ? user.image
                          : `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                          ,
                                          alt: "user.email",
                                          title: user.email
                                        }, null, 8, ["src", "title"])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_78, [
                          (task.budget)
                            ? (_openBlock(), _createBlock("div", _hoisted_79, [
                                _createVNode("div", _hoisted_80, [
                                  _hoisted_81,
                                  _createVNode("div", _hoisted_82, [
                                    _createVNode("p", null, _toDisplayString(_ctx.$t('estimation')), 1),
                                    _createVNode("p", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.usdPriceFormate(task.budget, null)), 1)
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_83, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('task_description')) + " :", 1)
                          ]),
                          _createVNode("p", null, [
                            _createVNode("small", null, _toDisplayString(task.description), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_84, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('item_lists')) + " :", 1)
                          ]),
                          ((task.items && task.items.length > 0) ||
                  task.estimation_items
                )
                            ? (_openBlock(), _createBlock("div", _hoisted_85, [
                                _createVNode("div", _hoisted_86, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.items ||
                      task.estimation_items, (item, itemIndex) => {
                                    return (_openBlock(), _createBlock("div", {
                                      class: "card p-1",
                                      key: itemIndex
                                    }, [
                                      _createVNode("div", {
                                        class: "card-header p-0",
                                        id: `heading${itemIndex}${taskIndex}${item.id}`
                                      }, [
                                        _createVNode("h2", _hoisted_87, [
                                          _createVNode("button", {
                                            class: "btn btn-link text-left shadow-none collapsed",
                                            type: "button",
                                            "data-toggle": "collapse",
                                            "data-target": `#collapse${itemIndex}${taskIndex}${item.id}`,
                                            "aria-expanded": "true",
                                            "aria-controls": "collapseOne"
                                          }, _toDisplayString(item.name), 9, ["data-target"])
                                        ])
                                      ], 8, ["id"]),
                                      _createVNode("div", {
                                        id: `collapse${itemIndex}${taskIndex}${item.id}`,
                                        class: "collapse",
                                        "aria-labelledby": `heading${itemIndex}${taskIndex}${item.id}`,
                                        "data-parent": "#accordionExample"
                                      }, [
                                        _createVNode("div", _hoisted_88, [
                                          _createVNode("div", _hoisted_89, [
                                            _createVNode("div", _hoisted_90, [
                                              _createVNode("p", null, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('item_name')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(item.name), 1),
                                              _createVNode("p", null, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('item_cost')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(item.cost, null)), 1),
                                              _createVNode("p", _hoisted_91, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('quantity')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(item.quantity), 1)
                                            ]),
                                            _createVNode("div", _hoisted_92, [
                                              _createVNode("p", null, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('mark_up')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(item.markup, item.markup_type)), 1),
                                              _createVNode("p", null, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('item_description')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(item.description), 1)
                                            ])
                                          ])
                                        ])
                                      ], 8, ["id", "aria-labelledby"])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (phase.attachments && phase.attachments.length)
                ? (_openBlock(), _createBlock("div", _hoisted_93, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_attachments')) + " : ", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (phase.attachments && phase.attachments.length)
                ? (_openBlock(), _createBlock("div", _hoisted_94, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.attachments, (image, imageIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-sm-6",
                        key: imageIndex
                      }, [
                        (image.extension === 'jpg' ||
                image.extension === 'png' ||
                image.extension === 'jpeg' ||
                image.extension === 'gif'
              )
                          ? (_openBlock(), _createBlock("div", _hoisted_95, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_96, [
                                    _createVNode("span", _hoisted_97, [
                                      _createVNode("span", _hoisted_98, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedAttachment(phase, image))
                              }, [
                                _hoisted_99
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_100, [
                                _createVNode("div", _hoisted_101, [
                                  _createVNode("img", {
                                    src: image.file,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_102, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'pdf')
                          ? (_openBlock(), _createBlock("div", _hoisted_103, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_104, [
                                    _createVNode("span", _hoisted_105, [
                                      _createVNode("span", _hoisted_106, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedAttachment(image))
                              }, [
                                _hoisted_107
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_108, [
                                _createVNode("div", _hoisted_109, [
                                  _createVNode("img", {
                                    src: _ctx.state.data.imageBaseUrl
                      ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                      : 'img/pdf.jpg'
                      ,
                                    alt: ""
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_110, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'doc' || image.extension === 'docx')
                          ? (_openBlock(), _createBlock("div", _hoisted_111, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_112, [
                                    _createVNode("span", _hoisted_113, [
                                      _createVNode("span", _hoisted_114, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedAttachment(image))
                              }, [
                                _hoisted_115
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_116, [
                                _hoisted_117,
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_118, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'mp4' ||
                image.extension === 'mov' ||
                image.extension === 'MOV' ||
                image.extension === 'wmv' ||
                image.extension === 'webm' ||
                image.extension === 'ogg' ||
                image.extension === 'avi' ||
                image.extension === 'x-ms-wmv'
              )
                          ? (_openBlock(), _createBlock("div", _hoisted_119, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_120, [
                                    _createVNode("div", _hoisted_121, [
                                      _createVNode("span", _hoisted_122, [
                                        _createVNode("span", _hoisted_123, _toDisplayString(_ctx.$t('loading1')), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("img", {
                                src: _ctx.state.data.imageBaseUrl
                  ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                  : 'img/video-icon.png'
                  ,
                                alt: "",
                                height: "200"
                              }, null, 8, ["src"]),
                              _createVNode("h5", null, _toDisplayString(image.name), 1),
                              _createVNode("p", _hoisted_124, _toDisplayString(image.size), 1),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedAttachment(image))
                              }, [
                                _hoisted_125
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (!(_ctx.state.data.companyInfo.logo || _ctx.state.data.estimation.logo))
            ? (_openBlock(), _createBlock("div", _hoisted_126, [
                _createVNode("a", {
                  "data-toggle": "modal",
                  class: "btn default-btn d-inline-block mr-2",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showCreateCompanyModel && _ctx.showCreateCompanyModel(...args)))
                }, _toDisplayString(_ctx.$t('add_company_information')), 1)
              ]))
            : _createCommentVNode("", true),
          ((_ctx.state.data.companyInfo.acknowledgement &&
          _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.estimation.acknowledgement &&
            _ctx.state.data.estimation.legal_statement)
        )
            ? (_openBlock(), _createBlock("p", _hoisted_127, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('company_contract_preview')), 1)
              ]))
            : _createCommentVNode("", true),
          ((_ctx.state.data.companyInfo.acknowledgement &&
          _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.estimation.acknowledgement &&
            _ctx.state.data.estimation.legal_statement)
        )
            ? (_openBlock(), _createBlock("div", _hoisted_128, [
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')), 1),
                  _createVNode("a", {
                    class: "btn default-btn btn-sm ms-2",
                    title: "Edit",
                    href: "javascript:void(0)",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.editCompany && _ctx.editCompany(...args)))
                  }, [
                    _hoisted_129,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                  ])
                ]),
                (_ctx.state.data.companyInfo.logo || _ctx.state.data.estimation.logo)
                  ? (_openBlock(), _createBlock("div", _hoisted_130, [
                      ((_ctx.state.data.companyInfo.logo && _ctx.state.data.companyInfo.logo.file) || (_ctx.state.data.estimation.logo && _ctx.state.data.estimation.logo.file)
            )
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            class: "rounded",
                            src: (_ctx.state.data.companyInfo.logo.file || _ctx.state.data.estimation.logo.file)
              ? (_ctx.state.data.companyInfo.logo.file || _ctx.state.data.estimation.logo.file)
              : (_ctx.state.data.companyInfo.logo || _ctx.state.data.estimation.logo)
              ,
                            alt: ""
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createBlock("img", {
                            key: 1,
                            class: "rounded",
                            src: _ctx.state.data.companyInfo.logo || _ctx.state.data.estimation.logo,
                            alt: ""
                          }, null, 8, ["src"]))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_131, [
                  _createVNode("ul", _hoisted_132, [
                    _createVNode("li", _hoisted_133, [
                      _createVNode("button", _hoisted_134, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                    ]),
                    _createVNode("li", _hoisted_135, [
                      _createVNode("button", _hoisted_136, _toDisplayString(_ctx.$t('legal_statement')), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_137, [
                    _createVNode("div", _hoisted_138, [
                      _createVNode("div", {
                        innerHTML: _ctx.state.data.estimation?.acknowledgement || _ctx.state.data.companyInfo.acknowledgement
                      }, null, 8, ["innerHTML"])
                    ]),
                    _createVNode("div", _hoisted_139, [
                      _createVNode("div", {
                        innerHTML: _ctx.state.data.estimation?.legal_statement || _ctx.state.data.companyInfo.legal_statement
                      }, null, 8, ["innerHTML"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_140, [
            _createVNode("ul", null, [
              (!_ctx.state.ui.isLoading.signaturePadLoad && _ctx.state.data.sendarSignature)
                ? (_openBlock(), _createBlock("li", _hoisted_141, [
                    _createVNode("label", _hoisted_142, [
                      _createTextVNode(_toDisplayString(_ctx.$t('signature')) + " ", 1),
                      _hoisted_143
                    ]),
                    (_ctx.state.data.sendarSignature)
                      ? (_openBlock(), _createBlock("div", _hoisted_144, [
                          _createVNode("img", {
                            src: _ctx.state.data.sendarSignature,
                            alt: ""
                          }, null, 8, ["src"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("button", {
                      for: "formFileSm",
                      class: "btn default-btn mr-2",
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.enableSignaturPad && _ctx.enableSignaturPad(...args)))
                    }, _toDisplayString(_ctx.$t('add_new_signature')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("li", {
                class: !_ctx.state.ui.isLoading.signaturePadLoad && _ctx.state.data.sendarSignature ? 'd-none' : ''
              }, [
                _createVNode("div", _hoisted_145, [
                  _createVNode("div", null, [
                    (_ctx.state.data.cropSignature)
                      ? (_openBlock(), _createBlock("div", _hoisted_146, [
                          _createVNode("img", {
                            src: _ctx.state.data.cropSignature,
                            alt: ""
                          }, null, 8, ["src"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_147, [
                  _createVNode("div", _hoisted_148, [
                    _createVNode("ul", null, [
                      _createVNode("li", null, [
                        _createVNode("div", _hoisted_149, [
                          _createVNode("button", _hoisted_150, [
                            _hoisted_151,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('upload_signature')), 1)
                          ]),
                          _createVNode("input", {
                            type: "file",
                            accept: "image/png, image/jpeg",
                            id: "profileUpdate",
                            onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.uploadSignatureFile($event)))
                          }, null, 32)
                        ])
                      ]),
                      _createVNode("li", null, [
                        _createVNode("button", {
                          class: "btn default-btn",
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.showSignaturePad && _ctx.showSignaturePad(...args)))
                        }, [
                          _hoisted_152,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('draw_signature')), 1)
                        ])
                      ]),
                      (_ctx.state.data.haveProfileSign)
                        ? (_openBlock(), _createBlock("li", _hoisted_153, [
                            _createVNode("div", _hoisted_154, [
                              _createVNode("button", {
                                for: "formFileSm",
                                class: "btn default-btn mr-2",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.userSignature('use')))
                              }, [
                                _hoisted_155,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('use_profile_signature')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("li", null, [
                        _createVNode("button", {
                          class: "btn red-btn",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.clearSignature()))
                        }, _toDisplayString(_ctx.$t('clear')), 1)
                      ])
                    ])
                  ])
                ])
              ], 2)
            ])
          ]),
          _createVNode("div", _hoisted_156, [
            _createVNode("label", _hoisted_157, _toDisplayString(_ctx.$t('attachments_docs')), 1),
            _createVNode(_component_DragAndDropZone, {
              onDrop: _withModifiers(_ctx.dropFiles, ["prevent"]),
              onDropFiles: _ctx.dropFiles
            }, null, 8, ["onDrop", "onDropFiles"]),
            (_ctx.state.data.projectEstimations.attachments &&
            _ctx.state.data.projectEstimations.attachments.length
          )
              ? (_openBlock(), _createBlock("div", _hoisted_158, [
                  _createVNode("div", _hoisted_159, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectEstimations
                .attachments, (image, imageIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-sm-6",
                        key: imageIndex
                      }, [
                        (image.file_type === 'jpg' ||
                  image.file_type === 'png' ||
                  image.file_type === 'jpeg' ||
                  image.file_type === 'gif'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_160, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_161, [
                                    _createVNode("span", _hoisted_162, [
                                      _createVNode("span", _hoisted_163, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeUploadSelectedImage(image))
                              }, [
                                _hoisted_164
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_165, [
                                _createVNode("div", _hoisted_166, [
                                  _createVNode("img", {
                                    src: image.file_link,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'pdf')
                          ? (_openBlock(), _createBlock("div", _hoisted_167, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_168, [
                                    _createVNode("span", _hoisted_169, [
                                      _createVNode("span", _hoisted_170, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeUploadSelectedImage(image))
                              }, [
                                _hoisted_171
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_172, [
                                _createVNode("div", _hoisted_173, [
                                  _createVNode("img", {
                                    src: _ctx.state.data.imageBaseUrl
                        ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                        : 'img/pdf.jpg'
                        ,
                                    alt: ""
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'doc' || image.file_type === 'docx')
                          ? (_openBlock(), _createBlock("div", _hoisted_174, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_175, [
                                    _createVNode("span", _hoisted_176, [
                                      _createVNode("span", _hoisted_177, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_178
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_179, [
                                _hoisted_180,
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'mp4' ||
                  image.file_type === 'mov' ||
                  image.file_type === 'MOV' ||
                  image.file_type === 'wmv' ||
                  image.file_type === 'webm' ||
                  image.file_type === 'ogg' ||
                  image.file_type === 'avi' ||
                  image.file_type === 'x-ms-wmv'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_181, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_182, [
                                    _createVNode("div", _hoisted_183, [
                                      _createVNode("span", _hoisted_184, [
                                        _createVNode("span", _hoisted_185, _toDisplayString(_ctx.$t('loading1')), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("img", {
                                src: _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                    : 'img/video-icon.png'
                    ,
                                alt: "",
                                height: "200"
                              }, null, 8, ["src"]),
                              _createVNode("h5", null, _toDisplayString(image.file_name), 1),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeUploadSelectedImage(image))
                              }, [
                                _hoisted_186
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectEstimations
                .attachments, (image, imageIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-sm-6",
                        key: imageIndex
                      }, [
                        (image.extension === 'jpg' ||
                  image.extension === 'png' ||
                  image.extension === 'jpeg' ||
                  image.extension === 'gif'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_187, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_188, [
                                    _createVNode("span", _hoisted_189, [
                                      _createVNode("span", _hoisted_190, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_191
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_192, [
                                _createVNode("div", _hoisted_193, [
                                  _createVNode("img", {
                                    src: image.file,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_194, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'pdf')
                          ? (_openBlock(), _createBlock("div", _hoisted_195, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_196, [
                                    _createVNode("span", _hoisted_197, [
                                      _createVNode("span", _hoisted_198, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_199
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_200, [
                                _createVNode("div", _hoisted_201, [
                                  _createVNode("img", {
                                    src: _ctx.state.data.imageBaseUrl
                        ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                        : 'img/pdf.jpg'
                        ,
                                    alt: ""
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_202, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'doc' || image.extension === 'docx')
                          ? (_openBlock(), _createBlock("div", _hoisted_203, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_204, [
                                    _createVNode("span", _hoisted_205, [
                                      _createVNode("span", _hoisted_206, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_207
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_208, [
                                _hoisted_209,
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_210, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'mp4' ||
                  image.extension === 'mov' ||
                  image.extension === 'MOV' ||
                  image.extension === 'wmv' ||
                  image.extension === 'webm' ||
                  image.extension === 'ogg' ||
                  image.extension === 'avi' ||
                  image.extension === 'x-ms-wmv'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_211, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_212, [
                                    _createVNode("div", _hoisted_213, [
                                      _createVNode("span", _hoisted_214, [
                                        _createVNode("span", _hoisted_215, _toDisplayString(_ctx.$t('loading1')), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("img", {
                                src: _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                    : 'img/video-icon.png'
                    ,
                                alt: "",
                                height: "200"
                              }, null, 8, ["src"]),
                              _createVNode("h5", null, _toDisplayString(image.name), 1),
                              _createVNode("p", _hoisted_216, _toDisplayString(image.size), 1),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_217
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_218, [
            (_ctx.state.data.selectedCustomers.length)
              ? (_openBlock(), _createBlock("div", _hoisted_219, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedCustomers, (customer, customerIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "col-md-4 col-sm-6 mb-2 px-2",
                      key: customerIndex
                    }, [
                      (customer.isEdit)
                        ? (_openBlock(), _createBlock("div", _hoisted_220, [
                            _createVNode("div", _hoisted_221, [
                              _createVNode("div", _hoisted_222, [
                                _createVNode("div", _hoisted_223, [
                                  _createVNode("label", _hoisted_224, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('enter_email_address')), 1)
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    disabled: "",
                                    class: customer.emailError
                        ? 'form-control error-field'
                        : 'form-control'
                        ,
                                    "onUpdate:modelValue": ($event: any) => (customer.email = $event)
                                  }, null, 10, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.email]
                                  ]),
                                  _createVNode("p", _hoisted_225, _toDisplayString(customer.emailError), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_226, [
                                _createVNode("div", _hoisted_227, [
                                  _createVNode("label", _hoisted_228, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('first_name')), 1)
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => (customer.first_name = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.first_name]
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_229, [
                                _createVNode("div", _hoisted_230, [
                                  _createVNode("label", _hoisted_231, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('last_name')), 1)
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => (customer.last_name = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.last_name]
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_232, [
                                _createVNode("div", _hoisted_233, [
                                  _createVNode("label", _hoisted_234, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('phone_number')), 1)
                                  ]),
                                  _createVNode("div", _hoisted_235, [
                                    _hoisted_236,
                                    _withDirectives(_createVNode("input", {
                                      type: "number",
                                      class: customer.phoneError ? 'form-control error-field' : 'form-control',
                                      placeholder: _ctx.$t('mobile_number_only'),
                                      "onUpdate:modelValue": ($event: any) => (customer.phone = $event)
                                    }, null, 10, ["placeholder", "onUpdate:modelValue"]), [
                                      [_vModelText, customer.phone]
                                    ]),
                                    _createVNode("p", _hoisted_237, _toDisplayString(customer.phoneError), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_238, [
                                _createVNode("div", _hoisted_239, [
                                  _createVNode("label", _hoisted_240, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('notify_by')), 1)
                                  ]),
                                  _createVNode("div", _hoisted_241, [
                                    _createVNode("div", _hoisted_242, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        id: "inlineCheckbox1",
                                        value: "true",
                                        disabled: customer.mailNotification,
                                        "onUpdate:modelValue": ($event: any) => (customer.mailNotification = $event)
                                      }, null, 8, ["disabled", "onUpdate:modelValue"]), [
                                        [_vModelCheckbox, customer.mailNotification]
                                      ]),
                                      _createVNode("label", _hoisted_243, _toDisplayString(_ctx.$t('email')), 1)
                                    ]),
                                    _createVNode("div", _hoisted_244, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        id: "inlineCheckbox2",
                                        value: "true",
                                        "onUpdate:modelValue": ($event: any) => (customer.smsNotification = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelCheckbox, customer.smsNotification]
                                      ]),
                                      _createVNode("label", _hoisted_245, _toDisplayString(_ctx.$t('sms')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", _hoisted_246, _toDisplayString(customer.mailNotificationError), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_247, [
                                _createVNode("div", _hoisted_248, [
                                  _createVNode("label", _hoisted_249, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('address')), 1)
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => (customer.address_line1 = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.address_line1]
                                  ])
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_250, [
                              _createVNode("a", {
                                class: "btn default-btn btn-sm to-upper",
                                title: "Update",
                                href: "javascript:void(\n                            0)",
                                onClick: ($event: any) => (_ctx.updateSelectCustomer(customerIndex))
                              }, [
                                _hoisted_251,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('update')), 1)
                              ], 8, ["onClick"])
                            ])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_252, [
                            _createVNode("div", _hoisted_253, [
                              _createVNode("a", {
                                class: "btn default-btn btn-sm mr-2",
                                title: "Edit",
                                href: "javascript:void(\n                            0)",
                                onClick: ($event: any) => (_ctx.editSelectCustomer(customerIndex))
                              }, [
                                _hoisted_254,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                              ], 8, ["onClick"]),
                              _createVNode("a", {
                                class: "btn btn-sm red-btn",
                                title: "Delete",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.showDelete(customer))
                              }, [
                                _hoisted_255,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                              ], 8, ["onClick"])
                            ]),
                            _createVNode("div", _hoisted_256, [
                              _createVNode("div", _hoisted_257, [
                                _createVNode("div", _hoisted_258, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('enter_email_address')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.email), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_259, [
                                _createVNode("div", _hoisted_260, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('first_name')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.first_name), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_261, [
                                _createVNode("div", _hoisted_262, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('last_name')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.last_name), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_263, [
                                _createVNode("div", _hoisted_264, [
                                  _createVNode("p", _hoisted_265, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_number')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.phone), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_266, [
                                _createVNode("div", _hoisted_267, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('notify_by')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    (customer.mailNotification)
                                      ? (_openBlock(), _createBlock("small", _hoisted_268, _toDisplayString(_ctx.$t('mail')), 1))
                                      : _createCommentVNode("", true),
                                    _hoisted_269,
                                    (customer.smsNotification)
                                      ? (_openBlock(), _createBlock("small", _hoisted_270, _toDisplayString(_ctx.$t('sms')), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_271, [
                                _createVNode("div", _hoisted_272, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('address')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.address_line1), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_273, [
                  _hoisted_274,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('customer_does_not_selected')) + " " + _toDisplayString(_ctx.$t('please_select_or_add_customer_email')), 1)
                ]))
          ]),
          _createVNode("div", _hoisted_275, [
            _createVNode("label", _hoisted_276, _toDisplayString(_ctx.$t('customer_emails')), 1),
            _createVNode(_component_multiselect, {
              modelValue: _ctx.state.data.selectedCustomers,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.data.selectedCustomers = $event)),
              "tag-placeholder": "Select or add customer email",
              placeholder: _ctx.$t('select_or_add_customer_email'),
              label: "code",
              "track-by": "code",
              options: _ctx.state.data.allCustomer,
              multiple: true,
              taggable: true,
              onTag: _ctx.addCustomerEmail,
              onSelect: _ctx.changeValue
            }, null, 8, ["modelValue", "placeholder", "options", "onTag", "onSelect"]),
            _withDirectives(_createVNode("p", { class: "text-red" }, _toDisplayString(_ctx.$t('please_add_valid_email_only')), 513), [
              [_vShow, _ctx.isInvalid]
            ])
          ]),
          (_ctx.state.data.selectedCustomers.length >= 2)
            ? (_openBlock(), _createBlock("div", _hoisted_277, [
                _withDirectives(_createVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.data.approveByAll = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.state.data.approveByAll]
                ]),
                _createVNode("label", _hoisted_278, _toDisplayString(_ctx.$t('approve_by_all_members')), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_279, [
            _withDirectives(_createVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.state.data.individualAcceptance = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.state.data.individualAcceptance]
            ]),
            _createVNode("label", _hoisted_280, _toDisplayString(_ctx.$t('is_individual_phase_accept_required')), 1)
          ]),
          _createVNode("div", _hoisted_281, [
            _createVNode("button", {
              type: "submit",
              class: "btn default-btn d-inline-block mr-2 outline",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.sendInvitationEstimation(0))),
              disabled: _ctx.state.ui.isPostLoading.saveEstimation
            }, _toDisplayString(_ctx.state.ui.isPostLoading.saveEstimation ? _ctx.$t('saving') : _ctx.$t('save_as_draft')), 9, ["disabled"]),
            _createVNode("button", {
              type: "submit",
              class: "btn default-btn d-inline-block mr-2",
              disabled: _ctx.iActiveValidation,
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.sendInvitationEstimation(1)))
            }, _toDisplayString(_ctx.state.ui.isPostLoading.sendEstimation ? _ctx.$t('loading1') : _ctx.$t('send')), 9, ["disabled"]),
            _createVNode("button", {
              type: "submit",
              class: "btn red-btn d-inline-block to-upper",
              onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.redirectToProjectToDo && _ctx.redirectToProjectToDo(...args)))
            }, _toDisplayString(_ctx.$t('cancel')), 1),
            (_ctx.state.ui.isLoading.isReadyToSend)
              ? (_openBlock(), _createBlock("label", _hoisted_282, [
                  _createVNode("span", _hoisted_283, _toDisplayString(_ctx.$t('some_phase_items_not_selected')) + " " + _toDisplayString(_ctx.$t('please_verify')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.state.data.showSuccesCustomModal)
          ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
              key: 0,
              onClose: _ctx.closeSuccessCustomModal,
              showModal: _ctx.state.data.showSuccesCustomModal,
              titleMessage: _ctx.state.data.successFulMessage
            }, null, 8, ["onClose", "showModal", "titleMessage"]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_284, [
          _createVNode("div", _hoisted_285, [
            _createVNode("div", _hoisted_286, [
              _createVNode("div", _hoisted_287, [
                _createVNode("div", _hoisted_288, [
                  _createVNode("h5", _hoisted_289, _toDisplayString(_ctx.$t('remove')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "modal",
                    onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.hideDelete && _ctx.hideDelete(...args))),
                    "aria-label": "Close"
                  }, [
                    _hoisted_290
                  ])
                ]),
                _createVNode("div", _hoisted_291, [
                  _createVNode("div", _hoisted_292, _toDisplayString(_ctx.$t('are_you_sure_you_want_to_remove')), 1)
                ]),
                _createVNode("div", _hoisted_293, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.removeSelectCustomer(_ctx.state.data.removeUser)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.delete ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn",
                    "data-dismiss": "modal",
                    onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.hideDelete && _ctx.hideDelete(...args)))
                  }, _toDisplayString(_ctx.$t('no')), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.data.showAddPhaseModal)
        ? (_openBlock(), _createBlock(_component_SendEstimationInvitationAddPhaseModal, {
            key: 1,
            showAddPhase: _ctx.state.data.showAddPhaseModal,
            editMode: _ctx.state.data.editMode,
            editData: _ctx.state.data.editData,
            projectAcknowledgementDetail: _ctx.state.data.projectEstimations,
            editFrom: _ctx.state.data.editFrom,
            checkData: _ctx.state.data.selectedItemList,
            phases: _ctx.state.data.sendPhases,
            onClose: _ctx.closeAddPhaseModal,
            onReset: _ctx.resetAddPhaseModal,
            onAddPhase: _ctx.addNewPhase,
            onUpdatePhase: _ctx.updatePhase,
            onResetChecked: _ctx.resetChecked,
            onUpdateTask: _ctx.updateTask
          }, null, 8, ["showAddPhase", "editMode", "editData", "projectAcknowledgementDetail", "editFrom", "checkData", "phases", "onClose", "onReset", "onAddPhase", "onUpdatePhase", "onResetChecked", "onUpdateTask"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_294, [
        _createVNode("div", _hoisted_295, [
          _createVNode("div", _hoisted_296, [
            _createVNode("div", _hoisted_297, [
              _createVNode("div", _hoisted_298, [
                _createVNode("h5", _hoisted_299, _toDisplayString(_ctx.$t('add_company_information')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                }, [
                  _hoisted_300
                ])
              ]),
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.createCompanyIfno,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_301, [
                _createVNode("div", _hoisted_302, [
                  _createVNode("div", _hoisted_303, [
                    (!_ctx.state.ui.isLoading.isCompanyEdit)
                      ? (_openBlock(), _createBlock("div", _hoisted_304, [
                          _createVNode("label", _hoisted_305, _toDisplayString(_ctx.$t('company_name')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.state.data.companyInfo.company_name = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_name]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.state.ui.isLoading.isCompanyEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_306, [
                        _createVNode("div", _hoisted_307, [
                          _createVNode("label", _hoisted_308, _toDisplayString(_ctx.$t('phone_number')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.state.data.companyInfo.company_phone_number = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_phone_number]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.ui.isLoading.isCompanyEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_309, [
                        _createVNode("div", _hoisted_310, [
                          _createVNode("label", _hoisted_311, _toDisplayString(_ctx.$t('email_address')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.state.data.companyInfo.company_email = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_email]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_312, [
                  _createVNode("label", _hoisted_313, _toDisplayString(_ctx.$t('company_logo')), 1),
                  (_ctx.state.data.estimation.logo)
                    ? (_openBlock(), _createBlock("div", _hoisted_314, [
                        _createVNode("img", {
                          src: _ctx.state.data.estimation.logo.file
                    ? _ctx.state.data.estimation.logo.file
                    : _ctx.state.data.estimation.logo
                    ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_315, [
                    _createVNode("div", _hoisted_316, [
                      _createVNode("button", _hoisted_317, [
                        _hoisted_318,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('upload')), 1)
                      ]),
                      _createVNode("input", {
                        type: "file",
                        accept: "image/png, image/jpeg",
                        id: "profileUpdate",
                        onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.uploadLogo($event)))
                      }, null, 32)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_319, [
                  _createVNode("label", _hoisted_320, _toDisplayString(_ctx.$t('add_acknowledgement')), 1),
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.acknowledgement,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.acknowledgement = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_321, [
                  _createVNode("label", _hoisted_322, _toDisplayString(_ctx.$t('add_conduct_of_contract')), 1),
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.legalStatement,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.legalStatement = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_323, [
                (_ctx.state.ui.isLoading.isCompanyEdit)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn default-btn d-inline-block",
                      onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                    }, _toDisplayString(_ctx.$t('update')), 1))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn default-btn d-inline-block",
                      onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.createCompanyIfno && _ctx.createCompanyIfno(...args)))
                    }, _toDisplayString(_ctx.$t('save_changes')), 1)),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                }, _toDisplayString(_ctx.$t('close')), 1)
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.data.showDeletePhaseConfirmation)
        ? (_openBlock(), _createBlock(_component_AppDeleteConfirmationModal, {
            key: 2,
            showConfirmationModal: _ctx.state.data.showDeletePhaseConfirmation,
            onButtonTrigger: _ctx.removeSelectedPhase,
            onHideConfirmation: _ctx.hideConfirmation,
            message: _ctx.state.data.deleteModalMessage
          }, null, 8, ["showConfirmationModal", "onButtonTrigger", "onHideConfirmation", "message"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.state.data.showSignaturePad)
      ? (_openBlock(), _createBlock(_component_SignaturePadModal, {
          key: 0,
          onClose: _ctx.hideSignaturePad,
          onUploadSignature: _ctx.uploadSignature,
          showModal: _ctx.state.data.showSignaturePad,
          from: 'estimation'
        }, null, 8, ["onClose", "onUploadSignature", "showModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSignatureUpload)
      ? (_openBlock(), _createBlock(_component_SignatureUploadModal, {
          key: 1,
          showModal: _ctx.state.data.showSignatureUpload,
          signatureFile: _ctx.state.data.uploadSignatureFile,
          from: 'estimation',
          onClose: _ctx.hideSignatureUpload,
          onUploadSignature: _ctx.uploadSignature
        }, null, 8, ["showModal", "signatureFile", "onClose", "onUploadSignature"]))
      : _createCommentVNode("", true)
  ], 64))
}